import type { SearchContentData } from '@/lib/api/search-content.server';
import type { ManualCategoriesStatus } from './default-search-viewport';

export interface SearchCategoriesContent {
    status: ManualCategoriesStatus;
    categories?: string;
}

/** Derive manual category slot status from resolved loader data. */
export function resolveSearchCategoriesFromContent(data: SearchContentData): SearchCategoriesContent {
    const markup = data.categories?.trim();

    if (markup) {
        return { status: 'ready', categories: markup };
    }

    return { status: 'empty', categories: undefined };
}
